import React from 'react';

export default function Contact() {
  return (
    <main
      style={{
        backgroundImage: 'url("/2.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          padding: '2rem',
          borderRadius: '1rem',
          color: 'white',
          maxWidth: '800px',
          textAlign: 'center',
        }}
      >
        <h2>Thank You for Reaching Out</h2>
        <p>
          We’re fully focused on our current projects and pipeline at this time.
        </p>
        <p>
          We appreciate your interest in NOVIONIX Labs and wish you all the best!
        </p>
      </div>
    </main>
  );
}